export type WallboxCondominioIntervalo = {
  id: string;
  distanciaDe: number;
  distanciaAte: number;
  precoMateriais: number;
  precoMaoObra: number;
};

export function criarIntervaloWallboxCondominio(
  distanciaDe = 0,
  distanciaAte = 20,
  precoMateriais = 0,
  precoMaoObra = 0
): WallboxCondominioIntervalo {
  const id =
    typeof crypto !== "undefined" && typeof crypto.randomUUID === "function"
      ? crypto.randomUUID()
      : `intervalo-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
  return {
    id,
    distanciaDe,
    distanciaAte,
    precoMateriais,
    precoMaoObra,
  };
}

/** Distâncias iniciais alinhadas à tabela comercial de condomínio. */
export function intervalosPadraoWallboxCondominio(): WallboxCondominioIntervalo[] {
  return [
    criarIntervaloWallboxCondominio(0, 20),
    criarIntervaloWallboxCondominio(20, 40),
    criarIntervaloWallboxCondominio(40, 60),
    criarIntervaloWallboxCondominio(60, 80),
  ];
}

export function totalIntervaloWallboxCondominio(
  intervalo: Pick<WallboxCondominioIntervalo, "precoMateriais" | "precoMaoObra">
): number {
  return (Number(intervalo.precoMateriais) || 0) + (Number(intervalo.precoMaoObra) || 0);
}

export function rotuloDistanciaIntervalo(
  intervalo: Pick<WallboxCondominioIntervalo, "distanciaDe" | "distanciaAte">
): string {
  const de = Number(intervalo.distanciaDe) || 0;
  const ate = Number(intervalo.distanciaAte) || 0;
  if (de <= 0) return `Até ${ate} m`;
  return `de ${de} a ${ate} m`;
}

export function parseIntervalosWallboxCondominio(raw: unknown): WallboxCondominioIntervalo[] {
  if (!Array.isArray(raw)) return [];
  return raw.map((row, index) => {
    const item = row && typeof row === "object" ? (row as Record<string, unknown>) : {};
    const id = typeof item.id === "string" && item.id ? item.id : `intervalo-${index}`;
    return {
      id,
      distanciaDe: Math.max(0, Number(item.distanciaDe ?? item.distancia_de) || 0),
      distanciaAte: Math.max(0, Number(item.distanciaAte ?? item.distancia_ate) || 0),
      precoMateriais: Math.max(0, Number(item.precoMateriais ?? item.preco_materiais) || 0),
      precoMaoObra: Math.max(0, Number(item.precoMaoObra ?? item.preco_mao_obra) || 0),
    };
  });
}

export function validarIntervalosWallboxCondominio(
  intervalos: WallboxCondominioIntervalo[]
): string | null {
  if (!intervalos.length) {
    return "Adicione ao menos um intervalo de distância.";
  }
  for (let i = 0; i < intervalos.length; i += 1) {
    const intervalo = intervalos[i];
    const de = Number(intervalo.distanciaDe) || 0;
    const ate = Number(intervalo.distanciaAte) || 0;
    if (ate <= de) {
      return `No intervalo ${i + 1}, a distância final deve ser maior que a inicial.`;
    }
    if (ate <= 0) {
      return `Informe a distância final do intervalo ${i + 1}.`;
    }
  }
  const algumComValor = intervalos.some((intervalo) => totalIntervaloWallboxCondominio(intervalo) > 0);
  if (!algumComValor) {
    return "Informe material e/ou mão de obra em ao menos um intervalo.";
  }
  return null;
}
